import Chai from "chai"

import Unit from "@frog/source/models/Unit.js"
import Stage from "@frog/source/models/Stage.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"

function findAction(actionmap, protoaction) {
    if(protoaction.position != undefined
    && protoaction.actionKey != undefined) {
        if(actionmap[Geometry.toString(protoaction.position)] instanceof Array) {
            return actionmap[Geometry.toString(protoaction.position)].find((action) => {
                return action.key == protoaction.actionKey
            })
        }
    }
    if(protoaction.movePosition != undefined
    && protoaction.skillPosition != undefined) {
        if(actionmap[Geometry.toString(protoaction.position)] instanceof Array) {
            return actionmap[Geometry.toString(protoaction.skillPosition)].find((action) => {
                if(action.previousPositions != undefined) {
                    return Geometry.equals(protoaction.movePosition, action.previousPositions[action.previousPositions.length - 1])
                } else if(action.positions != undefined) {
                    return Geometry.equals(protoaction.movePosition, action.positions[1])
                }
            })
        }
    }
}

export function performUnitActionSnapshotTest() {
    const alphastage = Stage.load(this.snapshot.alphastage)
    const expectedOmegastage = Stage.load(this.snapshot.omegastage)

    alphastage.idgen = () => "stub" // STUB

    let computedOmegastage = alphastage
    let steps = []
    this.snapshot.protoactions.forEach((protoaction) => {
        const actionmap = Unit.calculateActions(protoaction.unitKey, computedOmegastage)
        const action = findAction(actionmap, protoaction)
        Chai.expect(action).to.exist
        computedOmegastage = action.omegastage
        steps = steps.concat(action.steps)
    })

    delete computedOmegastage.idgen // UNSTUB

    const stages = [expectedOmegastage, computedOmegastage]
    stages.forEach((stage) => {
        delete stage.turn
        delete stage.actionMark // why is this out of sync?
        delete stage.events // TODO: why is undefined not equal to undefined??
        Objdict.forEach(stage.units, (unit) => {
            delete unit.family
            delete unit.level
            delete unit.maxlevel
            delete unit.hasEscaped
        })
    })

    this.computedOmegastage = computedOmegastage
    this.steps = steps

    Chai.expect(computedOmegastage).to.deep.equal(expectedOmegastage)

    // make less brittle: only assert what actually is changed???
    // make less brittle: don't compare static stuff
    // make less brittle: don't manually delete the isDead check
    // make faster: only run calculate action for the unit performing, not all units and all next turn.
    // make easier to debug: better diffing for what exactly is not deeply equal
    // make easier to write: how to identify the action moveposition skillposition and performer?
}

export function cannotPerformUnitActionSnapshotTest() {
    const alphastage = Stage.load(this.snapshot.alphastage)
    const protoaction = this.snapshot.protoactions[0]

    const actionmap = Unit.calculateActions(protoaction.unitKey, alphastage)
    const action = findAction(actionmap, protoaction)
    Chai.expect(action).to.not.exist
}
